import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-inn-explanation',
  templateUrl: './inn-explanation.component.html',
  styleUrls: ['./inn-explanation.component.scss']
})
export class InnExplanationComponent implements OnInit {
  innSubmissionNumber!: string;
  innExplanation!: string;

  constructor(private formService: FormService) {}
  
  ngOnInit(): void {
    this.innSubmissionNumber = this.currentForm.get('innSubmissionNumber')?.value;
    this.innExplanation = this.currentForm.get('innExplanation')?.value;
  }

  public clearInnSubmissionNumberInputField() {
    this.innSubmissionNumber = '';
    this.currentForm.patchValue({'innSubmissionNumber' : ''});
  }

  public clearInnExplanationInputField() {
    this.innExplanation = '';
    this.currentForm.patchValue({'innExplanation' : ''});
  }

  public updateInnSubmissionNumber(event: Event) {
    let control = this.currentForm.get('innSubmissionNumber');
    if (event && event.type === 'blur') {
      control?.markAsDirty();
      control?.markAsTouched();
      var target = document.activeElement;
      if (target && target.nodeValue === "cancel") {
        this.innSubmissionNumber = '';
        control?.markAsPristine({ onlySelf: true });
        control?.markAsUntouched();
      }
    }
    this.currentForm.patchValue({'innSubmissionNumber' : this.innSubmissionNumber});
  }

  public updateInnExplanation(event: Event) {
    if (event && event.type === 'blur') {
      var target = document.activeElement;
      if (target && target.nodeValue === "cancel") {
        this.innExplanation = '';
      }
    }
    this.currentForm.patchValue({'innExplanation' : this.innExplanation});
  }

  public cancelSubmissionNumberUpdate() {
    this.innSubmissionNumber = this.currentForm.get('innSubmissionNumber')?.value;
  }

  public cancelInnExplanationUpdate() {
    this.innExplanation = this.currentForm.get('innExplanation')?.value;
  }

  get isExistingInnName(): boolean {
    if(!this.currentForm.get('innSubmission')?.value) {
      this.clearInnExplanationInputField();
    }
    return this.currentForm.get('innSubmission')?.value == 'Yes';
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }
  
  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }
}
